import qs from 'querystring'

export const encodeQueryParams = (params) => qs.encode(params)
